export default __webpack_public_path__ + "static/media/craon11.fc447ae5.jpg";